(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/components/login.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/components/login.js');
'use strict';

const {
  Form
} = svs.ui.reactForm;
const TextInput = svs.ui.reactFormInputs.TextInput;
const Button = svs.ui.ReactButton;
const Login = () => {
  const {
    onLoginHandler
  } = svs.grassroots_partner.useLogin(svs);
  const [userName, setUserName] = React.useState('');
  const [password, setPassword] = React.useState('');
  return React.createElement("div", {
    className: "grid-row padding-2 login"
  }, React.createElement("div", {
    className: "col-xs-12 col-md-4 col-md-offset-4 f-content"
  }, React.createElement("h2", {
    className: "padding-bottom-1 align-center"
  }, "Gr\xE4sroten partner inloggning"), React.createElement(Form, {
    isVertical: true,
    onSubmit: onLoginHandler
  }, React.createElement("div", {
    className: "control-group padding-xs-bottom-2 padding-lg-bottom-3"
  }, React.createElement(TextInput, {
    errorMessageRequired: "Anv\xE4ndarnamn m\xE5ste anges",
    label: "Anv\xE4ndarnamn",
    name: "userName",
    onChange: e => setUserName(e.target.value),
    type: "text",
    value: userName
  }), React.createElement(TextInput, {
    errorMessageRequired: "L\xF6senord m\xE5ste anges",
    isRequired: true,
    label: "L\xF6senord",
    name: "password",
    onChange: e => setPassword(e.target.value),
    type: "password",
    value: password
  }), React.createElement(Button, {
    block: true,
    className: "margin-xs-top-3",
    focus: true,
    size: 300,
    type: "submit"
  }, "Logga in")))));
};
svs.grassroots_partner.Login = Login;

 })(window);